/* Copyright 2020 Enrico Ros. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import React from "react";
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import PeopleIcon from '@material-ui/icons/People';
import TwitterIcon from '@material-ui/icons/Twitter';
// import LocalCafeIcon from '@material-ui/icons/LocalCafe';
// import DirectionsBusIcon from '@material-ui/icons/DirectionsBus';
// import BathtubIcon from "@material-ui/icons/Bathtub";
// import HomeIcon from "@material-ui/icons/Home";
// import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';

import ChefHatIcon from "../icons/ChefHatIcon";
import {Brand, brandStyleKey} from "../Brand";


const annToIconMap = {
  'cdf': PeopleIcon,
  'chef': ChefHatIcon,
  '#ask': LiveHelpIcon, // help icon because it's not implemented yet
  '#top': TwitterIcon,
};

/**
 * An icon representing the chat.
 * Made from the 'Announcer' (chatSnapshot.announcer) and themed with the 'Theme' (chatSnapshot.theme)
 */
export const ChatIcon = ({chatSnapshot, noStyle}: { chatSnapshot: StageTypes.ChatSnapshot | null, noStyle?: boolean }) => {
  if (!chatSnapshot) {
    console.warn(`ChatIcon: invalid chatSnapshot. using default.`);
    return <LiveHelpIcon/>;
  }

  // find the icon
  let IconComponent = ContactSupportIcon;
  if (chatSnapshot.announcer in annToIconMap)
    IconComponent = annToIconMap[chatSnapshot.announcer];
  else
    console.warn(`ChatIcon: invalid announcer ${chatSnapshot.announcer}`);

  // plain icon, uncolored
  if (noStyle) return <IconComponent/>;

  // themed foreground icon
  const barStyle = brandStyleKey(chatSnapshot.theme);
  const iconColor = Brand.styles[barStyle].backgroundColor;
  return <IconComponent style={{color: iconColor}}/>;
}
